import { render, staticRenderFns } from "./crm-company-tag-manager.vue?vue&type=template&id=84acefc8&scoped=true&"
import script from "./crm-company-tag-manager.vue?vue&type=script&lang=js&"
export * from "./crm-company-tag-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84acefc8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84acefc8')) {
      api.createRecord('84acefc8', component.options)
    } else {
      api.reload('84acefc8', component.options)
    }
    module.hot.accept("./crm-company-tag-manager.vue?vue&type=template&id=84acefc8&scoped=true&", function () {
      api.rerender('84acefc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-crm-app/rfi_process/tabs/manage-tags/crm-company-tag-manager.vue"
export default component.exports